import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link, useNavigate, useParams } from "react-router-dom";
import $ from "jquery";
import axios from "axios";
import WOW from "wowjs";
import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from '../../hooks/Metatag'
export default function Malaria() {
    const [toggler, setToggler] = useState(true);
    const [index, setIndex] = useState(0);
    const navigate = useNavigate();
    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    const {disease_pagename} = useParams()

    const qs_disease_pagename = disease_pagename;

    const [perticularDiseaseList, setPerticularDiseaseList] = useState(null);

    const [perticularDiseaseId, setPerticularDiseaseId] = useState();


    useEffect(() => {
        let _obj = new Object();
        _obj.disease_pagename = qs_disease_pagename;
        _obj.disease_status = 1;

            axios.post(global.variables.strApiUrl + "/diseaseApi/getdiseaseList", _obj)
                .then((response_list) => {
                    if(response_list.data === 'error')
                {
                    navigate('/error-page')
                }
                else
                {
                    // pass the result in the success function of the respective page
                    setPerticularDiseaseList(response_list.data[0]);
                    setPerticularDiseaseId(response_list.data[0][0]?.disease_id)
                }
                });
       

    }, [qs_disease_pagename])


    const [diseaseSection, setdiseaseSectionList] = useState([]);
    
    useEffect(() => {
        let _obj = new Object();
        _obj.disease_sec_disease_id = perticularDiseaseId;
        _obj.disease_sec_status = 1;
        // setTimeout(() => {

            axios.post(global.variables.strApiUrl + "/diseasesectionApi/getdiseasesectionList", _obj)
                .then((response_list) => {
                    if(response_list.data === 'error')
                {
                    navigate('/error-page')
                }
                else
                {
                    // pass the result in the success function of the respective page
                    setdiseaseSectionList(response_list.data[0]);
                }
                });
        // }, 300);

    }, [perticularDiseaseId])
    
    useEffect(() => {
        // add class for home header and remove inner class
        $(".fixed-top").addClass("bg-header");

        // initiate the wow effect
        new WOW.WOW({
            live: false,
        }).init();


    }, [perticularDiseaseList, diseaseSection]);

    return (
        <>
            <Header main_className="bg-header"></Header>

            {/* Metatag  */}
            {
                perticularDiseaseList != null ? 
                <Metatag title={perticularDiseaseList[0].disease_pagetitle}
                        keywords={perticularDiseaseList[0].disease_meta_keywords} 
                        description={perticularDiseaseList[0].disease_meta_description}
                        />
                :
                null
            }
            
                    <Container fluid className="px-0 bg-visual position-relative" style={{ backgroundImage: "url('../images/bg-diseases.jpg')", backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}>
                        <img src={global.variables.strDomainUrl + "images/bg-blank.png"} alt="" title="" className="w-100" />
                        <div className="masthead d-flex align-items-center w-100">
                            <Container className="px-4 px-md-5">
                                <h1 className="mb-0 fw-bold text-white text-uppercase pb-xl-5 py-4">
                                    {
                                        perticularDiseaseList != null ?
                                        perticularDiseaseList[0].disease_cat_name
                                        :
                                        null
                                        }</h1>
                            </Container>
                        </div>
                    </Container>
                    {
                        perticularDiseaseList != null ?
                            perticularDiseaseList.length > 0 ?
                            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                                    {
                                        perticularDiseaseList[0].disease_cat_intro != null && perticularDiseaseList[0].disease_cat_intro != '' ?
                                           <>
                                           <Row className="align-items-start">
                                                <Col lg="12">
                                                    <p className="h4 m-0" dangerouslySetInnerHTML={{ __html : perticularDiseaseList[0].disease_cat_intro}}></p>
                                                </Col>
                                            </Row>
                                            <hr />
                                           </>
                                            :
                                            null

                                    }
                                    {
                                        perticularDiseaseList[0].disease_pic != null && perticularDiseaseList[0].disease_pic != '' ?  
                                        // perticularDiseaseList[0].disease_cat_name != perticularDiseaseList[0].disease_name ?
                                        <>
                                            <h2 className="fw-bold text-danger mb-4 wow fadeInUp">{perticularDiseaseList[0].disease_name}</h2>
                                            <Row className="mb-5 align-items-start">
                                            <Col lg="3">
                                                {
                                                    perticularDiseaseList[0].disease_pic != null && perticularDiseaseList[0].disease_pic != '' ?  
                                                    <img src={global.variables.strApiUrl + "/disease-picture/" + perticularDiseaseList[0].disease_pic} className="img-fluid rounded-3 mb-3 mb-lg-0"
                                                        alt={perticularDiseaseList[0].disease_name} title={perticularDiseaseList[0].disease_name} />
                                                    :
                                                    null
                                                }
                                            </Col>
                                            <Col>
                                                {
                                                    perticularDiseaseList[0].disease_intro != null && perticularDiseaseList[0].disease_intro != '' ?
                                                    <p className="m-0" dangerouslySetInnerHTML={{__html : perticularDiseaseList[0].disease_intro}}></p>
                                                    :
                                                    null
                                                }
                                            </Col>
                                            </Row>
                                            <hr/>
                                        </>
                                        : 
                                        <>
                                             <h2 className="fw-bold text-danger mb-4 wow fadeInUp">{perticularDiseaseList[0].disease_name}</h2>
                                            <Row className="mb-5 align-items-start">
                                            <Col>
                                                {
                                                    perticularDiseaseList[0].disease_intro != null && perticularDiseaseList[0].disease_intro != '' ?
                                                    <p className="m-0" dangerouslySetInnerHTML={{__html : perticularDiseaseList[0].disease_intro}}></p>
                                                    :
                                                    null
                                                }
                                            </Col>
                                            </Row>
                                            <hr/>
                                        </>
                                    }
                                    
                                    {
                                        diseaseSection?.map((val_disease_section)=>{
                                            return(
                                                <>
                                                    <Row className="my-5">
                                                        <Col md="3">
                                                            <h5 className="fw-bold text-dark wow fadeInUp">{val_disease_section.disease_sec_name}</h5>
                                                        </Col>
                                                        <Col md="9">
                                                            <div className="d-md-flex  fadeInUp">
                                                                <div className="pe-5 wow fadeInUp" dangerouslySetInnerHTML={{__html : val_disease_section.disease_sec_desc}}>

                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <hr />
                                                </>
                                            )
                                        })
                                    }
                            </Container >
                            :
                            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                                <Row>
                                    <span className="text-center"><b>No records found</b></span>
                                </Row>
                            </Container>
                        :
                            <Container className="p-md-5 p-4 content-bg bordr bg-white rounded-3 shadow-sm">
                                <Row>
                                    <span className="text-center">Loading...</span>
                                </Row>
                            </Container>
                    }
               


            {/* Breadcrumb */}
            <Container Container fluid className="small pt-3 p-0 bg-white d-flex justify-content-center mt-auto" >
                <Breadcrumb>
                    <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>Diseases</Breadcrumb.Item>
                    <Breadcrumb.Item active>{
                        perticularDiseaseList != null ?
                        perticularDiseaseList[0].disease_name
                        :
                        null
                        }
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Container>
            {/* Breadcrumb */}
        </>
    );
}